import React from 'react';
import { string } from 'prop-types';

const UpTriangle = ({ color = 'positive', fontSize = '11px', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_market_up ${className}`}
  />
);

UpTriangle.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default UpTriangle;
